import React, { Component } from 'react'
import DashboardFrame from '../../../components/Dashboard/DashboardFrame/DashboardFrame'
import SurveySettings from './SurveySettings/SurveySettings'
import SurveyFrame from './SurveyFrame/SurveyFrame'
import {Redirect, withRouter} from 'react-router'
import axios from "axios"
import Swal from "sweetalert2"
import {rootUrl} from '../../../config'
import {injectIntl} from 'react-intl'

class SurveyBuilder extends Component {
  constructor(props) {
    super(props)
    this.surveySettings = React.createRef()
    this.surveyFrame = React.createRef()

    this.state = {
      redirect: false
    }
  }

  onColorChange = (color) => {
    this.surveyFrame.current.changeColor(color)
  }

  onSelectedTranslationChange = (locale) => {
    this.surveyFrame.current.changeSelectedTranslation(locale)
  }

  onTranslationsChanged = (translations) => {
    this.surveyFrame.current.changeTranslations(translations)
  }

  onSurveyTitleChange = (title) => {
    this.surveyFrame.current.changeSurveyTitle(title)
  }

  onProjectChange = (id) => {
    this.surveyFrame.current.changeProjectId(id)
  }

  onSave() {
    const surveySettings = this.surveySettings.current.getSurveySettings()
    let pages = this.surveyFrame.current.getSurveyPages()

    pages = this.setRoutingPages(pages)

    axios.post(rootUrl + '/api/v1/survey/save_survey/', {
      projectId: surveySettings.selectedProjectId,
      surveySettings: surveySettings,
      pages: pages
    }).then(() => {
      Swal.fire({
        title: 'Onderzoek opgeslagen',
        text: 'Het nieuwe onderzoek is opgeslagen.',
        type: 'success',
        confirmButtonText: 'OK'
      }).then(() => {
        this.setState({redirect: true})
      })
    }).catch((error) => {
      console.log(error)
      Swal.fire({
        title: 'Oeps! Er is iets fout gegaan...',
        text: 'Er is iets misgegaan bij het opslaan van het onderzoek. Controleer uw internetverbinding en probeer het opnieuw.',
        type: 'error',
        confirmButtonText: 'OK'
      })
    })
  }

  // RoutingIndex:0 = next page, RoutingIndex:1 = last page.
  // Set page number routeToPage for every option.
  setRoutingPages(pages) {
    const lastPage = pages.length + 1
    for (let i = 0; i < pages.length; i++) {
      let components = pages[i].components
      const nextPage = i + 2
      for (let j = 0; j < components.length; j++) {
        if (components[j].type === "Routing") {
          let options = components[j].options
          for (let k = 0; k < options.length; k++) {
            let option = options[k]
            if (option.routingIndex === 0) {
              pages[i].components[j].options[k].routeToPage = nextPage
            } else if (option.routingIndex === 1) {
              pages[i].components[j].options[k].routeToPage = lastPage
            }
          }
        }
      }
    }

    return pages
  }

  render() {
    return (
      <DashboardFrame
        title={this.props.intl.formatMessage({id: "survey_builder.new_survey"})}
        dashboardTitle={this.props.intl.formatMessage({id: "survey_builder.new_survey"})}
        onLanguageChanged={(language) => this.props.onLanguageChanged(language)}>
        {this.state.redirect && <Redirect to={'/vragenlijsten'} />}
        <SurveySettings
          onColorChange={this.onColorChange.bind(this)}
          onSurveyTitleChange={this.onSurveyTitleChange.bind(this)}
          onSelectedTranslationChange={this.onSelectedTranslationChange.bind(this)}
          onTranslationsChange={this.onTranslationsChanged.bind(this)}
          onSave={this.onSave.bind(this)}
          ref={this.surveySettings}
          onSurveyChange={this.onProjectChange.bind(this)}
        />
        <SurveyFrame ref={this.surveyFrame} />
      </DashboardFrame>
    )
  }
}

export default withRouter(injectIntl(SurveyBuilder))
